import React, { Component }            from 'react';
import { Card }                        from 'react-bootstrap';
import { ClipLoader }                  from 'react-spinners';
import { FaCheckCircle }               from 'react-icons/fa';
import { FaTimesCircle }               from 'react-icons/fa';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import PubSub                          from 'pubsub-js';
import { EmployeeOnboardingConstants } from '../../environment';
import Questions                       from '../Questions';
import Reminder                        from './Reminder';
import { listGroupsFetchData }         from '../../../../../actions/employee-onboarding/list';
import { denyFetchData }               from '../../../../../actions/employee-onboarding/deny';
import { approveFetchData }            from '../../../../../actions/employee-onboarding/approve';

var apiHost = EmployeeOnboardingConstants.WebApiHost; 

class RequestItem extends Component {
    
  constructor(props) {
    super(props);
    this.state = {
      description : '',
      item        : this.props.item,
      expanded    : this.props.expanded
    };
    
    this.enter   = this.enter.bind(this);
    this.approve = this.approve.bind(this);
    this.deny    = this.deny.bind(this);
    
    this.updateDescription = this.updateDescription.bind(this);
  }
  
  subscriberApprove(msg, data) {
    if (this.props.listGroups.Groups.some(e => e.approve === data.approve_id) &&
        data.sr === this.state.item.SR) {
      this.enter();
    }
  }
  
  subscriberDeny(msg, data) {
    if (this.props.listGroups.Groups.some(e => e.ApproveId === data.approve_id) &&
        data.sr === this.state.item.SR) {
      this.enter();
    }
  }
  
  updateDescription(event) {
    if (event.target.value) {
      this.setState({ description: event.target.value, descriptionValid: true });
    }
    else {
      this.setState({ description: '', descriptionValid: false });
    }
  }

  enter(panel) {
    var params = {
      sr: this.state.item.SR
    };
    
    this.props.fetchDataListGroups(apiHost, params);
  }
  
  approve(approve, deny, sr) {    
    var body = {
      approve : approve,
      deny    : deny,
      sr      : sr
    };
    
    this.props.fetchDataApprove(apiHost, body);
  }

  deny(approve, deny, sr) {
    var body = {
      approve_id : approve,
      deny_id    : deny,
      reason     : 'Modified by Administrator',
      notes      : this.state.description ? this.state.description : 'Modified by Administrator',
      sr         : sr
    };
    
    this.props.fetchDataDeny(apiHost, body);
  }
  
  componentDidMount() {
    this.tokenDeny    = PubSub.subscribe('employee.approve.deny',    this.subscriberDeny.bind(this));
    this.tokenApprove = PubSub.subscribe('employee.approve.approve', this.subscriberApprove.bind(this));
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.tokenDeny);
    PubSub.unsubscribe(this.tokenApprove);
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.expanded !== prevProps.expanded && this.props.expanded === true) {
      this.enter();
    }
  }
  
  render() { 
    let questions = null;
    if (this.props.listGroups.Responses && this.props.listGroups.Responses.length > 0) {
      questions = 
        <Questions item={this.props.listGroups.Responses} />;
    }
      
    if (!this.props.listGroupsIsLoading && 
        !this.props.denyIsLoading &&
        !this.props.approveIsLoading &&
        this.props.listGroups.Groups && 
        this.props.listGroups.Groups.length > 0) {
            
      var items = [];
      for (var i = 0; i < this.props.listGroups.Groups.length; i++) {
        var item = this.props.listGroups.Groups[i];
        items.push(
          <Card key={i}>
            <div>
              <b>Group:</b> <span className='word-right'>{item.Group}</span>
            </div>
            <div>
              <b>Managed By:</b> <span className='word-right'>{item.ManagedBy ? item.ManagedBy : 'N/A'}</span>
            </div>
            <div>
              <b>Employee:</b> <span className='word-right'>{item.EmployeeName ? item.EmployeeName : 'N/A'}</span>
            </div>
            <div>
              <b>Reason:</b> <span className='word-right'>{item.Reason ? item.Reason : 'N/A'}</span>
            </div>
            <div>
              <b>Completed:</b> <span className='word-right'>{item.Completed ? 'true' : 'false'}</span>
            </div>
            <div>
              <b>Completed Date:</b> <span className='word-right'>{item.ModifiedDate}</span>
            </div>
            { item.Completed ?
              <div>
                <div>
                  <b>Completed By:</b> <span className='word-right'>{item.CompletedBy}</span>
                </div>
                <div>
                  <b>Status:</b> <span className={item.Approved ? 'word-right approved' : 'word-right denied'}>{item.Approved ? 'Approved' : 'Denied'}</span>
                </div>
                { !item.Approved ?
                  <div>
                    <div>
                      <b>Reason:</b> <span className='word-right'>{item.Reason}</span>
                    </div>
                    <div>
                      <b>Notes:</b> <span className='word-right'>{item.Notes}</span>
                    </div>
                  </div>
                  :
                  <span />
                }
              </div>
              : <span />
            }
            {
              !item.Completed ?
                <span>
                  <div>
                    <b>Approve:</b> 
                    <button onClick={this.approve.bind(this, item.ApproveId, item.DenyId, item.SR)} name={item.ApproveId} className='word-right'>
                      <FaCheckCircle size={24} />
                    </button>
                  </div>
                  <div>
                    <b>Deny:</b> 
                    <button onClick={this.deny.bind(this, item.ApproveId, item.DenyId, item.SR)} name={item.DenyId} className='word-right'>
                      <FaTimesCircle size={24} />
                    </button>
                  </div>
                  <div>
                    <textarea rows='4' cols='50' onChange={evt => this.updateDescription(evt)} />
                  </div>
                </span>
                :
                <span />
            }

            <Reminder key={i} item={this.props.listGroups.Item} group={item} />
          </Card>
        );
      }
    }
    
    return (
      <div>
        {questions}
        { !this.state.item.hasOwnProperty('DoorRequest') ?
          <div>
            <div>
              <b style={{ marginRight: '5px' }}>Name:</b>
              <span>
                {this.state.item.NewEmployeeName}
              </span>
            </div>
            <div>
              <b style={{ marginRight: '5px' }}>Equivalent User:</b>
                { this.state.item.MakeLikeName ?
                  <span>
                    {this.state.item.MakeLikeName}
                  </span>
                :
                  <span>
                    N/A
                  </span>
                }
            </div>
          </div>
          :
          <div>
            <b style={{ marginRight: '5px' }}>Door Request:</b>
            <span>
              {this.state.item.DoorRequest ? 'true' : 'false'}
            </span>
          </div>
        }
        <div>
          <b style={{ marginRight: '5px' }}>Completed:</b>
          <span>
            {this.state.item.Completed ? 'true' : 'false'}
          </span>
        </div>
        { this.props.listGroupsIsLoading ?
          <ClipLoader
            color={'#072659'} 
            loading={this.props.listGroupsIsLoading} 
          />
          : <span />
        }
        { this.props.denyIsLoading ?
          <ClipLoader
            color={'#072659'} 
            loading={this.props.denyIsLoading} 
          />
          : <span />
        }
        { this.props.approveIsLoading ?
          <ClipLoader
            color={'#072659'} 
            loading={this.props.approveIsLoading} 
          />
          : <span />
        }
        {items}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    listGroups: state.employee.list.listGroups,
    listGroupsHasErrored: state.employee.list.listGroupsHasErrored,
    listGroupsIsLoading: state.employee.list.listGroupsIsLoading,
    deny: state.employee.deny.deny,
    denyHasErrored: state.employee.deny.denyHasErrored,
    denyIsLoading: state.employee.deny.denyIsLoading,
    approve: state.employee.approve.approve,
    approveHasErrored: state.employee.approve.approveHasErrored,
    approveIsLoading: state.employee.approve.approveIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataListGroups: (host, params) => dispatch(listGroupsFetchData(host, params)),
    fetchDataDeny:       (host, params) => dispatch(denyFetchData(host, params)),
    fetchDataApprove:    (host, params) => dispatch(approveFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequestItem));
